import { ImplicitLoginPage } from "@lcms/react-identity-routes";
import { LoadingPage } from "src/components/loading";
import { routes } from "../../routing/routes";

export default function Page() {
    return (
        <ImplicitLoginPage defaultRoute={routes.index}>
            <LoadingPage />
        </ImplicitLoginPage>
    );
}